import React from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const ProposteAnalisiPieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                {/* COMMENTATO SOLO PER TEMA DI IMPAGINAZIONE
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Area")}
                        dataProviderName={"statisticsviews/proposalsperarea/aggregated/views_opportunities_proposal/_related_area_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box> 
                */}
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Shop")}
                        dataProviderName={"statisticsviews/proposalspershop/aggregated/views_opportunities_proposal/_related_shop_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Buyer Agent")}
                        dataProviderName={"statisticsviews/proposalsperagent/aggregated/views_opportunities_proposal/_related_buyerAgent_fullname"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_buyerAgent_fullname', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Seller Agent")}
                        dataProviderName={"statisticsviews/proposalsperagent/aggregated/views_opportunities_proposal/_related_sellerAgent_fullname"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_sellerAgent_fullname', addFilter)}
                    />
                </Box>
            </Box>
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Source")}
                        dataProviderName={"statisticsviews/proposalspersource/aggregated/views_opportunities_proposal/_related_source_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Status")}
                        dataProviderName={"statisticsviews/proposalspersource/aggregated/views_opportunities_proposal/status"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('status', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Proposal by Product")}
                        dataProviderName={"statisticsviews/proposalspersource/aggregated/views_opportunities_proposal/product"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('product', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default ProposteAnalisiPieSet;
